import React from 'react';

import Messaging from '../../assets/icons/results-messaging.svg?react';
import { Modal } from 'components/v2/Modal/Modal';
import { themes } from 'kb-shared';
import styled from 'styled-components';

import ContactDiv from './ContactDiv';

interface Props {
  visible: boolean;
  onDismiss: () => void;
}

const ResultsContactModal = ({ visible, onDismiss }: Props) => (
  <Modal onCancel={onDismiss} open={visible} title="Contact">
    <Container>
      <Content>
        <Title>
          <Messaging />
          Talk to Us
        </Title>
        <ContactDiv className="results-contact-modal" />
      </Content>
    </Container>
  </Modal>
);

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  position: relative;
  min-width: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;

  background-color: ${themes.colors.white};
  border-left: 8px solid ${themes.colors.yellow.primary};
  padding: 24px;

  @media ${themes.queries.minTablet} {
    min-width: 400px;
  }

  & .results-contact-modal {
    padding: 0;
    border-left: 0;
    box-shadow: none;
  }
`;

export const Title = styled.h1`
  font-size: 28px;
  color: ${themes.colors.neutral.primaryNavy};
  margin-bottom: 24px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  & > svg {
    transform: scale(1.5);
    margin-right: 16px;
  }
`;

export default ResultsContactModal;
